export default "__VITE_ASSET__votcT1tw__"